import React, { useState } from 'react';
import {
    MDBContainer,
    MDBNavbar,
    MDBNavbarBrand,
    MDBBtn,
    MDBIcon,
    MDBRow,
    MDBCol,
    MDBCard,
    MDBCardBody,
    MDBCardTitle,
    MDBCardText,
    MDBCarousel,
    MDBCarouselItem,
    MDBFooter,
    MDBNavbarNav,
    MDBNavbarItem,
    MDBNavbarLink,
    MDBNavbarToggler,
    MDBCollapse,
    MDBDropdown,
    MDBDropdownToggle,
    MDBDropdownMenu,
    MDBDropdownItem,
    MDBCardImage
} from 'mdb-react-ui-kit';
// import logodark from "../motos_lp/assets/images/Easy-MembrLogo.png";
// import Footer from '../motos_lp/component/Footer';
import logodark from "../../motos_lp/assets/images/Easy-MembrLogo.png";
import Footer from "../../motos_lp/component/Footer";
import { CoachingCenter, Dance, Fitness, LandingHome, yoga } from '../../components/images/ClassAssets';
import { Link } from 'react-router-dom';

function ClassesLandingPage() {

    const [openBasic, setOpenBasic] = useState(false);
    const logourl = localStorage.getItem("loggedUserInfo") ? (JSON.parse(localStorage.getItem("loggedUserInfo")).gymlogoUrl || logodark) : logodark;

    return (
        <>

            <MDBNavbar fixed='top' expand='lg' light bgColor='light'>
                <MDBContainer fluid className='d-flex align-items-center justify-content-between w-80'>
                    <img src={logodark} alt="Default Logo" className="newLogo" style={{ height: "60px" }} />

                    <div>

                        <MDBNavbarToggler
                            aria-controls='navbarSupportedContent'
                            aria-expanded='false'
                            aria-label='Toggle navigation'
                            onClick={() => setOpenBasic(!openBasic)}
                        >
                            <MDBIcon icon='bars' fas />
                        </MDBNavbarToggler>

                        <MDBCollapse navbar open={openBasic}>
                            <MDBNavbarNav className='mr-auto mb-2 mb-lg-0'>
                                <MDBNavbarItem>
                                    <MDBNavbarLink active aria-current='page' href='#'>
                                        Home
                                    </MDBNavbarLink>
                                </MDBNavbarItem>
                                <MDBNavbarItem>
                                    <MDBNavbarLink href={localStorage.getItem("loggedUserInfo") ? "/classdashboard" : "/classlogin"}>Login</MDBNavbarLink>
                                    {/* <li className="list-inline-item"><Link2 to={localStorage.getItem("loggedUserInfo") ? "/classdashboard" : "/classlogin"} className="text-dark fw-semibold text-uppercase">Login</Link2></li> */}
                                </MDBNavbarItem>
                                <MDBNavbarItem>
                                    <MDBNavbarLink href={localStorage.getItem("loggedUserInfo") ? "/classdashboard" : "/classsignup"}>Sign Up</MDBNavbarLink>
                                    {/* <li className="list-inline-item"><Link2 to={localStorage.getItem("loggedUserInfo") ? "/classdashboard" : "/classlogin"} className="text-dark fw-semibold text-uppercase">Login</Link2></li> */}
                                </MDBNavbarItem>
                            </MDBNavbarNav>
                        </MDBCollapse>
                    </div>

                </MDBContainer>
            </MDBNavbar>








            <div style={{ paddingTop: '120px' }}>
                <header className="bg-light">
                    <MDBContainer fluid className='w-75 pb-5'>
                        <MDBRow className='align-items-center'>
                            <MDBCol md="6">
                                <h1 className="display-4 font-weight-bold">
                                    Simplify Class Bookings, Maximize Engagement!
                                </h1>
                                <p className="lead">
                                    Effortless Scheduling. Seamless Payments. More Bookings.
                                </p>
                                <MDBBtn color="primary">
                                    <MDBBtn color="primary">
                                        <Link to="/classsignup" className="text-white" style={{ textDecoration: 'none' }}>
                                            Get Started Now
                                        </Link>
                                    </MDBBtn>
                                </MDBBtn>
                            </MDBCol>
                            <MDBCol md="6">
                                <MDBCardImage src={LandingHome} alt="login form" className='rounded-5 shadow-5 w-100' style={{ objectFit: "cover", maxHeight: "650px", minHeight: "600px" }} />
                            </MDBCol>
                        </MDBRow>
                    </MDBContainer>
                </header>

                {/* Features Section */}
                <section className="py-5">
                    <MDBContainer fluid className='w-75 pb-5'>
                        <h2 className="text-center mb-5">Why Choose EasyMembr?</h2>
                        <MDBRow>
                            {[
                                {
                                    icon: "calendar-check",
                                    title: "Quick & Easy Bookings",
                                    text: "Let customers book classes in just a few clicks.",
                                },
                                {
                                    icon: "bell",
                                    title: "Automated Reminders",
                                    text: "Reduce no-shows with SMS & email alerts.",
                                },
                                {
                                    icon: "credit-card",
                                    title: "Seamless Payments",
                                    text: "Integrated payment gateway for hassle-free transactions.",
                                },
                                {
                                    icon: "users",
                                    title: "Membership & Attendance Tracking",
                                    text: "Keep your community engaged.",
                                },
                                {
                                    icon: "cogs",
                                    title: "Customizable Plans",
                                    text: "Flexible options to fit your business needs.",
                                },
                            ].map((feature, index) => (
                                <>
                                    <MDBCol md="4" key={index} className="mb-4">
                                        <MDBCard>
                                            <MDBCardBody className="text-center d-flex p-4">
                                                <MDBIcon icon={feature.icon} size="3x" className="mb-3" style={{ color: "#50c878" }} />
                                                <div class="text-left px-4">
                                                    <MDBCardTitle>{feature.title}</MDBCardTitle>
                                                    <MDBCardText>{feature.text}</MDBCardText>
                                                </div>
                                            </MDBCardBody>
                                        </MDBCard>
                                    </MDBCol>
                                </>
                            ))}
                        </MDBRow>
                    </MDBContainer>
                </section>

                {/* Use Cases Section */}
                <section className="py-5 bg-light">
                    <MDBContainer fluid className='w-75 pb-5'>
                        <h2 className="text-center mb-5">
                            For Fitness Studios, Gyms, Spa, salon, Tutors, Coaches & More!
                        </h2>
                        <MDBRow>
                            {[
                                { image: Fitness, title: "Fitness Studios" },
                                { image: yoga, title: "Yoga Studios" },
                                { image: Dance, title: "Dance Classes" },
                                { image: CoachingCenter, title: "Coaching Centers" },
                            ].map((useCase, index) => (
                                <MDBCol md="3" key={index} className="mb-4">
                                    <MDBCard>
                                        <div hover>
                                            <img src={useCase.image} alt={useCase.title} className="img-fluid" />
                                            <div overlay="white-slight" />
                                        </div>
                                        <MDBCardBody className="text-center">
                                            <MDBCardTitle>{useCase.title}</MDBCardTitle>
                                        </MDBCardBody>
                                    </MDBCard>
                                </MDBCol>
                            ))}
                        </MDBRow>
                    </MDBContainer>
                </section>

                {/* Testimonials Section */}
                <section className="py-5">
                    <MDBContainer fluid className='w-75 pb-5'>
                        <h2 className="text-center mb-5">What Our Customers Say</h2>
                        <MDBCarousel
                            activeItem={1}
                            length={3}
                            showControls={true}
                            showIndicators={true}
                            className="z-depth-1"
                        >
                            {[
                                {
                                    image: "https://mdbootstrap.com/img/new/avatars/1.jpg",
                                    text: "Managing class creation and handling staff is incredibly easy. The intuitive system allows for seamless scheduling, efficient staff management, and hassle-free updates.",
                                    name: "John Doe",
                                },
                                {
                                    image: "https://mdbootstrap.com/img/new/avatars/2.jpg",
                                    text: "The payment process is fast and the user-friendly interface makes transactions smooth. It's also easy to monitor all revenue in real time, ensuring complete financial transparency.",
                                    name: "Jane Smith",
                                },
                                {
                                    image: "https://mdbootstrap.com/img/new/avatars/3.jpg",
                                    text: "Creating events and tracking them is effortless. When it comes to user bookings, members can easily book classes by selecting their preferred date, making the process smooth and convenient.",
                                    name: "Alice Johnson",
                                }
                            ].map((testimonial, index) => (
                                <>
                                    <MDBCarouselItem itemId={index + 1} key={index}>
                                        <div class="text-left d-flex align-items-center justify-content-center">
                                            <img
                                                src={testimonial.image}
                                                alt={testimonial.name}
                                                style={{ width: "100px" }}
                                                className="rounded-circle mb-3"
                                            />
                                            <div class="p-5" style={{ maxWidth: "50%" }}>
                                                <p className="lead">{testimonial.text}</p>
                                                <h5>{testimonial.name}</h5>
                                            </div>
                                        </div>
                                    </MDBCarouselItem>



                                    {/* <div class="text-left d-flex align-items-center justify-content-center"><img src="https://mdbootstrap.com/img/new/avatars/2.jpg" alt="Jane Smith" class="rounded-circle mb-3" style={{ width: "150px" }} /><div class="p-5" style={{ maxWidth: "50%" }}>
                                        <p class="lead">The payment integration is seamless and easy to use. The payment integration is seamless and easy to use. The payment integration is seamless and easy to use. The payment integration is seamless and easy to use. </p>
                                        <h5>Jane Smith</h5></div></div> */}


                                </>
                            ))}
                        </MDBCarousel>
                    </MDBContainer>
                </section>

                <section className="py-5 bg-success bg-opacity-75 bg-gradient text-white">
                    <MDBContainer fluid className='w-75 pb-5'>
                        <h2 className="text-center mb-4">Get Started in Minutes!</h2>
                        <p className="lead text-center mb-4">
                            No tech skills required. Just sign up, set up, and start accepting bookings today!
                        </p>
                        <div className="text-center">
                            <Link to="/classsignup" ><MDBBtn color='dark'>Sign Up Now</MDBBtn></Link>
                        </div>
                    </MDBContainer>
                </section>

                {/* Footer Section */}
                <Footer />
            </div>
        </>
    );
}

export default ClassesLandingPage
